import { datasetTypeConfig, datasetTypeToLabel, ImpactDataset } from "@/hooks/useEcoInventDatasets";
import ImpactPill from "../Impact/ImpactPill";
import Table, { Column, TableProps } from "../Table/Table";

export const datasetTableColumns: Column<ImpactDataset>[] = [
  {
    key: "name",
    label: "Name",
    minWidth: "150px",
    searchable: true,
    sortable: true,
    maxWidth: "2fr",
  },
  {
    key: "unit",
    label: "Unit",
    searchable: true,
    sortable: true,
    maxWidth: "140px",
    minWidth: "130px",
  },
  {
    key: "geography",
    label: "Geography",
    searchable: true,
    sortable: true,
    maxWidth: "180px",
    minWidth: "180px",
  },
  {
    key: "dataset_type",
    label: "Type",
    filterable: true,
    sortable: true,
    maxWidth: "180px",
    minWidth: "180px",
    renderer: (record) => datasetTypeToLabel(record.dataset_type),
  },
  {
    key: "impact",
    label: "Impact",
    sortable: true,
    renderer: (record) => <ImpactPill impact={record?.impact} />,
    maxWidth: "300px",
    minWidth: "250px",
  },
];

export interface DatasetTableProps
  extends Omit<Omit<TableProps<ImpactDataset>, "columns">, "rowKey"> {
  columns?: Column<ImpactDataset>[];
}

export default function DatasetTable(props: DatasetTableProps) {
  return (
    <Table<ImpactDataset>
      {...props}
      rowKey="id"
      availableFilters={{
        dataset_type: Object.values(datasetTypeConfig).map((x) => ({
          label: x.label,
          value: x.key,
        })),
      }}
      columns={props.columns || datasetTableColumns}
    />
  );
}
